export default "__VITE_ASSET__DVG$seZZ__"